const InvoiceEditIcon = () => {
  return (
    <svg
      style={{ transform: "scale(1.7)" }}
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8333 18.0726H7.83318C7.46517 18.0726 7.1665 17.7739 7.1665 17.4059C7.1665 17.0379 7.46517 16.7393 7.83318 16.7393H19.8333C20.2013 16.7393 20.5 17.0379 20.5 17.4059C20.5 17.7739 20.2013 18.0726 19.8333 18.0726Z"
        fill="#1062D0"
      />
      <path
        d="M1.16649 18.0726C0.991357 18.0726 0.821596 18.0042 0.695293 17.8771C0.531717 17.7135 0.465147 17.478 0.517557 17.2531L1.48648 13.1419C1.51496 13.0211 1.57616 12.9108 1.66422 12.8237L13.9212 0.566718C14.6751 -0.18801 15.9941 -0.189801 16.7497 0.566718L18.0067 1.82357C18.3844 2.20134 18.5925 2.70362 18.5925 3.23781C18.5925 3.77216 18.3844 4.27525 18.0067 4.65205L5.74955 16.9082C5.66166 16.9963 5.5513 17.0576 5.43135 17.0859L1.32014 18.0549C1.2687 18.0674 1.21711 18.0726 1.16649 18.0726V18.0726ZM2.74073 13.6318L2.0625 16.5099L4.94078 15.8317L17.0635 3.709C17.1898 3.5827 17.2591 3.41571 17.2591 3.23781C17.2591 3.06007 17.1898 2.8921 17.0635 2.76677L15.8066 1.50895C15.555 1.25732 15.115 1.25732 14.8644 1.50895L2.74073 13.6318ZM5.27754 16.4372H5.28649H5.27754Z"
        fill="#1062D0"
      />
      <path
        d="M14.8457 7.53533C14.6752 7.53533 14.5044 7.47038 14.3747 7.33969L11.2314 4.19659C10.971 3.93617 10.971 3.51396 11.2314 3.25354C11.492 2.99296 11.9142 2.99296 12.1747 3.25354L15.3178 6.39664C15.5782 6.65706 15.5782 7.07927 15.3178 7.33969C15.1871 7.47038 15.0165 7.53533 14.8457 7.53533Z"
        fill="#1062D0"
      />
    </svg>
  );
};

export default InvoiceEditIcon;
